module.exports = __webpack_public_path__ + "img/audio.43e93a96.svg";